import React, { useRef, useCallback } from "react";

// Vertical fader driven by drag.
export default function Fader({ value, min = 0, max = 1, onChange, height = 150, testId, hint }) {
  const trackRef = useRef(null);
  const dragging = useRef(false);
  const range = max - min;
  const norm = (value - min) / range;
  const thumbTravel = height - 34;
  const top = (1 - norm) * thumbTravel;

  const setFromClientY = useCallback(
    (clientY) => {
      const rect = trackRef.current.getBoundingClientRect();
      let rel = clientY - rect.top - 17;
      rel = Math.max(0, Math.min(thumbTravel, rel));
      const n = 1 - rel / thumbTravel;
      onChange(min + n * range);
    },
    [min, range, thumbTravel, onChange]
  );

  const onDown = useCallback(
    (e) => {
      dragging.current = true;
      setFromClientY(e.clientY);
      const onMove = (ev) => dragging.current && setFromClientY(ev.clientY);
      const onUp = () => {
        dragging.current = false;
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
      };
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
      e.preventDefault();
    },
    [setFromClientY]
  );

  return (
    <div
      ref={trackRef}
      onPointerDown={onDown}
      role="slider"
      aria-valuenow={value}
      title={hint || "Drag up/down to set level"}
      className="relative cursor-grab active:cursor-grabbing"
      style={{ width: 34, height, touchAction: "none" }}
      data-testid={testId}
    >
      <div
        className="absolute left-1/2 -translate-x-1/2 rounded-full inset-panel"
        style={{ width: 5, height: "100%", background: "#000" }}
      />
      <div
        className="absolute left-1/2 -translate-x-1/2 rounded-sm"
        style={{
          top,
          width: 30,
          height: 34,
          background: "linear-gradient(180deg,#3a3a3a,#1e1e1e)",
          borderBottom: "3px solid #000",
          boxShadow: "0 3px 6px rgba(0,0,0,0.7)",
        }}
      >
        <div className="absolute top-1/2 left-1 right-1 -translate-y-1/2 h-[2px] bg-cyan-400/70" />
      </div>
    </div>
  );
}
